import { permissionCode } from "src/app/shared";
import { FeaturePermissionState } from "../permission.models";

export const backlogsPermissionState: FeaturePermissionState = {
  edit: [permissionCode.TASK_MANAGEMENT_BACKLOG_EDIT],
  editAnother: [permissionCode.TASK_MANAGEMENT_BACKLOG_EDIT_OTHER],
  view: [permissionCode.TASK_MANAGEMENT_BACKLOG_VIEW],
  viewAnother: [permissionCode.TASK_MANAGEMENT_BACKLOG_VIEW_OTHER]
}
